import React from 'react'
import './Access.css'
import Login from './Login'
import Register from './Register'
import { useAuthFlow } from '../../Context/AuthFlowContext';

function Access() {

    const { authFlow, toggleAuthFlow } = useAuthFlow();

  return (
    <div className='access_container'>
        {authFlow === 'login' ? <Login/> : <Register/>}
    </div>
  )
}

export default Access